// Thin wrapper around Plausible custom events. Safe to call during SSR.
export const track = (event, props) => {
  if (typeof window === "undefined" || typeof window.plausible !== "function")
    return
  window.plausible(event, props ? { props } : undefined)
}
